import { useContext, useEffect, useState } from "react";
import QuestContext from "../../../../components/QuestWrapper";
import {
  BrandTheme,
  ChallengesProps,
  ICriteria,
  QuestThemeData,
} from "../types/Challenges.type";
import { fetchData, getUserAuth, verifyActions } from "./apiFunction";
import ChallengesShow from "./ChallengesShow";
import { ThemeManager } from "./ThemeManager";
import General, { useGeneral } from "../../../../general";
import config from "../../../../config";

export const Challenges = ({
  userId,
  token,
  questId,
  styleConfig,
  enableVariation,
  uniqueUserId,
  uniqueEmailId,
  isLoader,
  loaderComponent,
  showCoin,
  completedActionIcon,
  incompletedActionIcon,
  showCredits,
  showSvg,
  customSvg,
  entityAuthenticationToken,
}: ChallengesProps) => {
  const { apiKey, apiSecret, entityId, apiType, themeConfig, user } = useContext(
    QuestContext.Context
  );
  let GeneralFunctions = new General("mixpanel", apiType);

  const [criterias, setCriterias] = useState<ICriteria[]>([]);
  const [suggestions, setSuggestions] = useState<ICriteria[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true); // Track API loading state
  const [claimStatus, setClaimStatus] = useState(null);
  const [verifiedFlag, setVerifiedFlag] = useState(false);
  const [isVerify, setIsVerify] = useState(false);
  const [showFooter, setShowFooter] = useState(true);
  const [questUserId, setQuestUserId] = useState(userId || "");
  const [questToken, setQuestToken] = useState(token || "");
  const [campaignVariationId, setCampaignVariationId] = useState("");

  const [campaignXp, setCampaignXp] = useState(0);
  const [questThemeData, setQuestThemeData] = useState<QuestThemeData>({
    accentColor: "",
    theme: "",
    borderRadius: "",
    buttonColor: "",
    images: [],
  });

  const [BrandTheme, setBrandTheme] = useState<BrandTheme>({
    accentColor: "",
    background: "",
    borderRadius: "",
    buttonColor: "",
    contentColor: "",
    fontFamily: "",
    logo: "",
    primaryColor: "",
    secondaryColor: "",
    tertiaryColor: "",
    titleColor: "",
  });

  const general = useGeneral('quest')

  const themeManager = new ThemeManager(
    BrandTheme,
    styleConfig,
    themeConfig,
    questThemeData
  );

  const BACKEND_URL =
    apiType === "STAGING" ? config.BACKEND_URL_STAGING : config.BACKEND_URL;

  useEffect(() => {
    const loadData = async () => {
      try {
        setIsLoading(true); // Set loading to true before fetching
        let userDetails = await getUserAuth({
          BACKEND_URL,
          apiKey,
          entityId,
          uniqueUserId,
          uniqueEmailId,
          userId,
          token,
          GeneralFunctions,
          entityAuthenticationToken,
        })
        setQuestUserId(userDetails?.userId || '');
        setQuestToken(userDetails?.token || '');
        await fetchData({
          BACKEND_URL,
          apiKey,
          apiSecret,
          entityId,
          questId,
          enableVariation,
          userId: userDetails?.userId,
          token: userDetails?.token,
          uniqueUserId,
          uniqueEmailId,
          setCriterias,
          setQuestThemeData,
          setBrandTheme,
          GeneralFunctions,
          setCampaignVariationId,
          setIsVerify,
          setClaimStatus,
          setCampaignXp,
          setShowFooter
        });
      } finally {
        setIsLoading(false); // Set loading to false after fetching
      }
    };

    loadData();
  }, []);

  // verify challenges actions - both v1 and v2
  const formSubmitHandler = async () => {
    const BACKEND_URL =
      apiType === "STAGING"
        ? config.BACKEND_URL_STAGING
        : config.BACKEND_URL;

    GeneralFunctions.fireTrackingEvent(
      "quest_challenges_verification",
      "gamifiedquiz"
    );
    setVerifiedFlag(true);

    try {
      let res = await verifyActions({
        BACKEND_URL,
        apiKey,
        apiSecret,
        entityId,
        questId,
        criterias,
        userId: questUserId,
        token: questToken,
        campaignVariationId: campaignVariationId,
        GeneralFunctions,
      });
      let data = res;
      if (!data?.failedCriterias || data?.failedCriterias.length === 0) {
        let updatedCriterias = criterias.map((criteria) => ({ ...criteria, completed: data?.find((el: any) => el?.actionId === criteria?.actionId)?.success }));
        setCriterias(updatedCriterias);
      } else {
        setCriterias(
          criterias.map((criteria) => ({
            ...criteria,
            completed: !data?.failedCriterias.includes(criteria.actionId),
          }))
        );
      }
    } catch (error) {
      GeneralFunctions.captureSentryException(error);
      console.error("Error during verification:", error);
    }
  };

  useEffect(() => {
    const filteredSuggestions = criterias.filter(
      (criteria) =>
        criteria.title &&
        criteria.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    setSuggestions(filteredSuggestions);
  }, [searchTerm, criterias]);

  useEffect(() => {
    if (criterias.length > 0 && claimStatus !== null && claimStatus !== true && verifiedFlag == false && isVerify) {
      formSubmitHandler();
    }
  }, [criterias])

  useEffect(() => {
    general.trackEvent(
      'quest-challenges-loaded',
      (uniqueUserId || userId || user.userId)!,
      {},
      true,
      !uniqueUserId,
      true
    )
  }, [])

  if (isLoading) {
    if (isLoader) {
      return loaderComponent || <div>Loading...</div>;
    } else {
      return null;
    }
  }

  return (
    <div>
      {suggestions && (
        <ChallengesShow
          suggestions={suggestions}
          setSearchTerm={setSearchTerm}
          themeManager={themeManager}
          completedActionIcon={completedActionIcon}
          incompletedActionIcon={incompletedActionIcon}
          showCoin={showCoin}
          campaignXp={campaignXp}
          showCredits={showCredits}
          showSvg={showSvg}
          customSvg={customSvg}
          showFooter={showFooter}
        />
      )}
    </div>
  );
};

export default Challenges;
